import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { AppCard, AppModal } from '@/layout/AppComponents';
import { Tab, Tabs } from 'react-bootstrap';
import styled from 'styled-components';
import Translator from '../../../../../components/helpers/Translator';

export default function GGCLApplicableDateBlock(props) {
  const {
    obligationID,
    isH3 = false,
  } = props;
  const polevel1 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level1?.[obligationID]
  );
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('obligation');

  const content = (
    <span
      className={
        polevel1?.obligation?.obligationVersion?.hasPreviousVersion
          ? 'pointer'
          : ''
      }
      onClick={() =>
        polevel1?.obligation?.obligationVersion?.hasPreviousVersion &&
        setShowModal(true)
      }
    >
      {`• ${ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name={
            polevel1?.obligation?.obligationVersion?.hasPreviousVersion
              ? 'applicable.version.to.date'
              : 'applicable.from.date'
          }
          variables={{
            date: polevel1?.obligation?.obligationVersion?.applicableDate,
          }}
        />
      )}${
        polevel1?.obligation?.obligationVersion?.hasPreviousVersion
          ? ` - ${ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="applicable.version.to.date.check"
              />
            )}`
          : ''
      }`}
    </span>
  );

  return (
    <>
      {polevel1?.obligation?.obligationVersion?.applicableDate && (
        <>
          {isH3 ? (
            <h3>{content}</h3>
          ) : (
            <div className="font-weight-bold text-danger">{content}</div>
          )}
        </>
      )}
      {polevel1?.obligation?.obligationVersion?.hasPreviousVersion && (
        <AppModal
          show={showModal}
          size="xl"
          title={ReactDOMServer.renderToString(
            <Translator file="evaluation" name="obligation.name" />,
          )}
          onClose={() => setShowModal(false)}
        >
          <Tabs onSelect={(v) => setActiveTab(v)}>
            {polevel1?.obligation?.obligationVersion?.nextObligation !==
              polevel1?.obligation?.obligationVersion?.obligation && (
              <Tab
                eventKey="obligation"
                title={ReactDOMServer.renderToString(
                  <Translator file="evaluation" name="obligation.name" />,
                )}
                className="p-3 border border-top-0 bg-white"
              >
                <Container>
                  <div className="row">
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.version.to.date"
                            variables={{
                              date: polevel1?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        {polevel1?.obligation?.hasFormat ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                polevel1?.obligation?.obligationVersion
                                  ?.obligation,
                            }}
                          />
                        ) : (
                          <div style={{ whiteSpace: 'pre-line' }}>
                            {
                              polevel1?.obligation?.obligationVersion
                                ?.obligation
                            }
                          </div>
                        )}
                      </AppCard>
                    </div>
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.from.date"
                            variables={{
                              date: polevel1?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              polevel1?.obligation?.obligationVersion
                                ?.nextObligation,
                          }}
                        />
                      </AppCard>
                    </div>
                  </div>
                </Container>
              </Tab>
            )}
            {polevel1?.obligation?.obligationVersion?.nextEvidence !==
              polevel1?.obligation?.obligationVersion?.evidence && (
              <Tab
                eventKey="evidence"
                title={ReactDOMServer.renderToString(
                  <Translator file="module-legalCompliance" name="evidences" />,
                )}
                className="p-3 border border-top-0 bg-white"
              >
                <Container>
                  <div className="row">
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.version.to.date"
                            variables={{
                              date: polevel1?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              polevel1?.obligation?.obligationVersion?.evidence,
                          }}
                        />
                      </AppCard>
                    </div>
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.from.date"
                            variables={{
                              date: polevel1?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              polevel1?.obligation?.obligationVersion
                                ?.nextEvidence,
                          }}
                        />
                      </AppCard>
                    </div>
                  </div>
                </Container>
              </Tab>
            )}
            {polevel1?.obligation?.obligationVersion?.nextNextDate !==
              polevel1?.obligation?.obligationVersion?.nextDate && (
              <Tab
                eventKey="nextDate"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="module.lc.nextDate"
                  />,
                )}
                className="p-3 border border-top-0 bg-white"
              >
                <Container>
                  <div className="row">
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.version.to.date"
                            variables={{
                              date: polevel1?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              polevel1?.obligation?.obligationVersion?.nextDate,
                          }}
                        />
                      </AppCard>
                    </div>
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.from.date"
                            variables={{
                              date: polevel1?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              polevel1?.obligation?.obligationVersion
                                ?.nextNextDate,
                          }}
                        />
                      </AppCard>
                    </div>
                  </div>
                </Container>
              </Tab>
            )}
          </Tabs>
          {polevel1?.obligation?.obligationVersion?.versionComment && (
            <div className="alert alert-info mt-3">
              {polevel1?.obligation?.obligationVersion?.versionComment}
            </div>
          )}
        </AppModal>
      )}
    </>
  );
}

const Container = styled.div`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  .card {
    border: 1px solid #ddd;
  }
`;
